<template>
  <div class="log-export app-page">
    <vue-headful title="ALICE | Export FAQ Report"></vue-headful>
    <div class="row wrapper">
      <div class="col-sm-12 col-xl-6 b-card">
        <div class="card">
          <header class="card-header no-margin">
            <div class="card-header-title">Export FAQ Report</div>
          </header>
          <div class="card-content">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <!--                style="display: flex;flex-direction: column;justify-content: flex-end;"-->
                <label class="label">Channel</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="channel">
                        <option
                            v-for="channel in channelList"
                            :value="channel"
                            :key="channel"
                        >{{ channel.toUpperCase() }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Language</label>
              </div>
              <!--              <div class="field-body">-->
              <!--                <div class="field checkbox-lines">-->
              <!--                  <b-checkbox v-model="language" native-value="TH">-->
              <!--                    TH-->
              <!--                  </b-checkbox>-->
              <!--                  <b-checkbox v-model="language" native-value="EN">-->
              <!--                    EN-->
              <!--                  </b-checkbox>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="language">
                        <option
                            v-for="language in languageList"
                            :value="language"
                            :key="language"
                        >{{ language.toUpperCase() }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Group By</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="groupBy">
                        <option
                            v-for="groupBy in groupByList"
                            :value="groupBy.value"
                            :key="groupBy.value"
                        >{{ groupBy.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="field is-horizontal">-->
<!--              <div class="field-label is-normal">-->
<!--                <label class="label">Product Model</label>-->
<!--              </div>-->
<!--              <div class="field-body">-->
<!--                <div class="field">-->
<!--                  <div class="control is-expanded">-->
<!--                    <div class="select is-fullwidth">-->
<!--                      <select v-model="productModel">-->
<!--                        <option-->
<!--                            v-for="productModel in productModelList"-->
<!--                            :value="productModel"-->
<!--                            :key="productModel"-->
<!--                        >{{ productModel }}</option>-->
<!--                      </select>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Date Time</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded">
                    <div class="select is-fullwidth" @change="toggleDateMode">
                      <select v-model="dateMode">
                        <option value="today">Today</option>
                        <option value="last7day">Last 7 days</option>
                        <option value="last30day">Last 30 days</option>
                        <option value="custom">Custom</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal" v-if="dateMode === 'custom'">
              <div class="field-label is-normal">
                <label class="label"></label>
              </div>
              <div class="field-body">
                <div class="field is-grouped">
                  <div class="control is-expanded has-icons-left">
                    <datetime
                        :max-datetime="dateTo"
                        type="datetime"
                        input-class="input"
                        v-model="dateFrom"
                    ></datetime>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="calendar-alt"></font-awesome-icon>
                    </span>
                  </div>
                  <div class="control is-expanded has-icons-left">
                    <datetime
                        :min-datetime="dateFrom"
                        :max-datetime="dateNow"
                        type="datetime"
                        input-class="input"
                        v-model="dateTo"
                    ></datetime>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="calendar-alt"></font-awesome-icon>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!--            <div class="field is-horizontal">-->
            <!--              <div class="field-label is-normal">-->
            <!--                <label class="label">Client ID</label>-->
            <!--              </div>-->
            <!--              <div class="field-body">-->
            <!--                <div class="field">-->
            <!--                  <div class="control is-expanded">-->
            <!--                    <div class="select is-fullwidth">-->
            <!--                      <select v-model="clientID">-->
            <!--                        <option v-for="cl in clientList" :value="cl" :key="cl">{{ cl }}</option>-->
            <!--                      </select>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <footer class="card-footer no-padding">
            <div class="card-footer-item btn btn-link"  @click="exportData" :disabled="isLoading">Export</div>
          </footer>
        </div>
      </div>
      <div class="col-sm-12 col-xl-6 b-card">
        <div class="card">
          <header class="card-header no-margin">
            <div class="card-header-title">Export FAQ Report History</div>
          </header>
          <div class="card-content">
            <b-table hover :fields="fields" :items="allActiveFaqReportZipFileDetail" responsive="sm" show-empty>
              <template #cell(fileName)="data">
                  <span class="">{{ data.item.fileName || data.item.id }}</span>
              </template>

              <template #cell(status)="data">
                <div class="text-status">
                    <span>{{ data.item.status }}</span>
                  </div>
              </template>

              <template #cell(createdAt)="data">
                  <span class="">{{ convertDate(data.item.createdAt)  }}</span>
              </template>

              <template #cell(action)="data">
                <span  v-if="data.item.status === 'pending'">In Progress</span>
                <div v-if="data.item.status === 'finish'">
                  <span class="item-tool-btn mr-2"  @click="downloadFile(data.item)">
                    <em title="Download" class="fas fa-download"></em>
                  </span>
                  <span class="item-tool-btn" @click="deleteDownloadFile(data.item)">
                    <em title="Remove" class="fa fa-trash"></em>
                  </span>
                </div>
              </template>

              <template #empty="">
                  <div class="text-center mt-3">
                    <span>No data</span>
                  </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>

    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div id="download-area"></div>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import { BTable } from 'bootstrap-vue';
import alice from '../alice-api';

export default {
  name: 'faq-report-export',
  components: {
    'b-table': BTable,
  },
  data() {
    return {
      channel: 'all',
      channelList: [
        'all',
        'ada',
        'line'
      ],
      dateMode: 'last7day',
      dateFrom: '',
      dateTo: '',
      dateNow: '',
      language: 'all',
      languageList: [
        'all',
        'th',
        'en'
      ],
      groupBy: 'faqid',
      groupByList: [
        {
          name: 'FAQ Id',
          value: 'faqid'
        },
        {
          name: 'Brother FAQ Id',
          value: 'brotherfaqid'
        },
        {
          name: 'FAQ Level 3',
          value: 'faqlevelthree'
        },
        {
          name: 'Product Model',
          value: 'productmodel'
        }
      ],
      productModel: '',
      productModelList: [
        'A',
        'B',
        'C'
      ],
      isFullPage: true,
      isLoading: false,
      fileDetail: [],
      fields: [
        {
          key: 'fileName',
          label: 'File Name',
        },
        {
          key: 'status',
          label: 'Status',
        },
        {
          key: 'createdAt',
          label: 'Created Date',
        },
        { key: 'action', label: 'Actions' },
      ],
      activeInterval: null,
    };
  },
  mounted() {
    this.loadAllActiveFaqReportZipFileDetail();
    this.setIntervalForStatusExport();
    this.initDateInput(6);
  },
  beforeDestroy() {
    if (this.activeInterval) {
      clearInterval(this.activeInterval);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.activeInterval) {
      clearInterval(this.activeInterval);
    }
    next();
  },
  methods: {
    ...mapActions({
      loadAllFaqReportZipFileDetail: 'faqReport/loadAllFaqReportZipFileDetail',
      loadAllActiveFaqReportZipFileDetail: 'faqReport/loadAllActiveFaqReportZipFileDetail',
    }),
    setIntervalForStatusExport() {
      if (this.activeInterval) {
        clearInterval(this.activeInterval);
      }
      this.activeInterval = setInterval(() => {
        this.loadAllActiveFaqReportZipFileDetail();
        this.getExportStatus();
      }, 30000);
    },
    initDateInput(number) {
      const now = moment().utcOffset(420);
      this.dateNow = now.endOf('day').toISOString();
      this.dateTo = now.endOf('day').toISOString();
      this.dateFrom = now
        .subtract(number, 'days')
        .startOf('day')
        .toISOString();
    },
    toggleDateMode() {
      const mode = this.dateMode;
      if (mode === 'today') {
        const now = moment().utcOffset(420);
        this.dateNow = now.endOf('day').toISOString();
        this.dateTo = now.endOf('day').toISOString();
        this.dateFrom = now.startOf('day').toISOString();
      } else if (mode === 'last7day') {
        this.initDateInput(6);
      } else if (mode === 'last30day') {
        this.initDateInput(29);
      } else if (mode === 'custom') {
        this.initDateInput(44);
      }
    },
    exportData() {
      this.isLoading = true;
      const data = this.getRequestBody();
      alice
        .exportFaqReportToFile(data)
        .then(() => {
          this.isLoading = false;
          this.loadAllActiveFaqReportZipFileDetail();
          this.setIntervalForStatusExport();
        })
        .catch(() => {
          this.isLoading = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'No log data for this criteria.',
            position: 'is-bottom',
          });
        });
    },
    getRequestBody() {
      const from = moment(this.dateFrom).format('x');
      const to = moment(this.dateTo).format('x');

      const body = {
        date: {
          from,
          to
        },
        groupBy: this.groupBy
      };

      if (this.channel !== 'all') {
        body.channel = this.channel;
      }
      if (this.language !== 'all') {
        body.language = this.language.toUpperCase();
      }

      return body;
    },
    getExportStatus() {
      const allLog = this.allActiveFaqReportZipFileDetail;
      const isFinish = allLog.every((log) => log.status === 'finish' || log.status === 'deleted');
      if (isFinish) {
        if (this.activeInterval) {
          clearInterval(this.activeInterval);
        }
      }
    },
    isDisabled(status) {
      return status !== 'finish';
    },
    convertDate(dateStr) {
      return moment(dateStr).format('D/M/YYYY');
      // return moment(dateStr).format('D/M/YYYY, h:mm:ss a');
    },
    downloadFile(file) {
      const { id, fileName } = file;
      this.isLoading = true;
      alice
        .downloadFaqReportZipFile(id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const elem = document.getElementById('download-area');
          link.href = url;
          link.setAttribute('download', `${fileName}.zip`);
          elem.innerHTML = '';
          elem.appendChild(link);
          link.click();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'An error occurred, cannot export logs data.',
            position: 'is-bottom',
          });
        });
    },
    async deleteDownloadFile(file) {
      const { id } = file;
      this.isLoading = true;
      await alice
        .deleteFaqReportDownloadFile(id)
        .then(() => {
          this.isLoading = false;
          this.loadAllActiveFaqReportZipFileDetail();
          this.setIntervalForStatusExport();
        })
        .catch(() => {
          this.isLoading = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'An error occurred, cannot export logs data.',
            position: 'is-bottom',
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      allFaqReportZipFileDetail: 'faqReport/allFaqReportZipFileDetail',
      allActiveFaqReportZipFileDetail: 'faqReport/allActiveFaqReportZipFileDetail',
    }),
  },
};
</script>
<style lang="scss" scoped>
.log-export {
  text-align: left;
  overflow-x: hidden;
  overflow-y: auto;
  .card-header-title {
    font-size: 1.2rem;
  }
  .wrapper {
    margin: 10px;
  }
  .checkbox-lines {
    padding-top: 8px;
    .checkbox {
      margin-right: 10px;
    }
  }

  .text-status {
    text-transform: capitalize;
  }

  .item-tool-btn {
    cursor: pointer;
  }

}

</style>
